/* Reescrita do rotulo de time na vitrine (Match Day).
 *
 * O catalogo tem titulos genericos de proposito. Este script poe o rotulo na frente,
 * SO no que o cliente ve. Titulo do produto na Shopify, <title> da PDP, Open Graph e
 * JSON-LD continuam genericos.
 *
 * O DICIONARIO NAO MORA AQUI. O tema so conhece codigos de 3 digitos; a traducao vem
 * de um servico proprio (URL em data-md-labels no <html>), pra que nenhum rotulo de
 * marca precise existir dentro do tema da Shopify.
 *
 * Velocidade: a resposta fica guardada no navegador por 24h. Visita repetida le do
 * cache de forma sincrona e reescreve antes do primeiro paint (zero flash). So a
 * primeira visita de cada cliente depende da rede; enquanto o dicionario nao chega,
 * os titulos ficam numa fila e sao reescritos assim que ele chega.
 *
 * Se o servico estiver fora do ar, os titulos ficam genericos e a loja segue normal.
 *
 * Tres modos, por atributo:
 *   data-md-team="030"        -> PREFIXA o rotulo no titulo do produto
 *   data-md-team-title="030"  -> SUBSTITUI o codigo no titulo da colecao
 *   data-md-team-label="030"  -> TROCA o texto inteiro do elemento pelo rotulo (menu)
 */
(function () {
  "use strict";

  var ATTR_PREFIX = "data-md-team";
  var ATTR_TITLE = "data-md-team-title";
  var ATTR_LABEL = "data-md-team-label";
  var DONE = "data-md-named";
  var CACHE_KEY = "md_labels_v1";
  var TTL = 24 * 3600 * 1000;

  var MAP = null;
  var fila = [];

  /* ---------- dicionario: cache local primeiro, rede depois ---------- */

  function doCache() {
    try {
      var cru = localStorage.getItem(CACHE_KEY);
      if (!cru) return null;
      var o = JSON.parse(cru);
      if (!o || !o.map || Date.now() - o.ts > TTL) return null;
      return o.map;
    } catch (e) {
      return null;
    }
  }

  function guardar(map) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), map: map }));
    } catch (e) {}
  }

  function buscar(revalidando) {
    var base = document.documentElement.getAttribute("data-md-labels");
    if (!base || typeof fetch !== "function") return;
    var opcoes = { credentials: "omit" };
    /* Na revalidacao forco o navegador a perguntar ao servidor. Sem isso ele serviria a
       copia local de ate 24h atras e um dicionario novo so apareceria no dia seguinte -
       foi assim que as ligas ficaram exibindo o codigo depois de entrarem no servico.
       O Worker responde 304 quando nada mudou, entao o custo e de alguns bytes. */
    if (revalidando) opcoes.cache = "no-cache";
    fetch(base + "/teams", opcoes)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (j) {
        if (!j || !Object.keys(j).length) return;
        if (revalidando) {
          atualizar(j);
          return;
        }
        guardar(j);
        aplicar(j);
      })
      .catch(function () {
        /* servico fora do ar: titulos ficam genericos, a loja segue vendendo */
      });
  }

  /* Dicionario novo chegando por cima de um cache antigo.
     Reaplico SO no que ficou "sem-rotulo": esses ainda estao com o texto original,
     entao trocar e seguro. Quem ja recebeu rotulo fica como esta ate o cache virar,
     porque prefixar de novo duplicaria o nome no titulo do produto. */
  function atualizar(novo) {
    var antes = "";
    try {
      antes = JSON.stringify(MAP);
    } catch (e) {}
    if (JSON.stringify(novo) === antes) return;
    guardar(novo);
    MAP = novo;
    var pendentes = document.querySelectorAll("[" + DONE + '="sem-rotulo"]');
    for (var i = 0; i < pendentes.length; i++) {
      pendentes[i].removeAttribute(DONE);
      tratar(pendentes[i]);
    }
    reescreverMetaDaColecao();
  }

  function aplicar(map) {
    MAP = map;
    var pendentes = fila;
    fila = [];
    for (var i = 0; i < pendentes.length; i++) tratar(pendentes[i]);
    varrer(document);
    reescreverMetaDaColecao();
  }

  /* ---------- reescrita ---------- */

  function padraoColecao() {
    return /(?:Edition|Drop|Series|Collection\s*N[°º])\s*\d{3}/gi;
  }

  function rotuloDe(codigo) {
    if (!codigo || !MAP) return null;
    var n = MAP[codigo];
    return typeof n === "string" && n ? n : null;
  }

  function prefixar(el) {
    var rotulo = rotuloDe(el.getAttribute(ATTR_PREFIX));
    if (!rotulo) {
      el.setAttribute(DONE, "sem-rotulo");
      return;
    }
    var texto = (el.textContent || "").replace(/^\s+|\s+$/g, "");
    if (texto && texto.indexOf(rotulo) !== 0) el.textContent = rotulo + " " + texto;
    el.setAttribute(DONE, "1");
  }

  function substituir(el) {
    var rotulo = rotuloDe(el.getAttribute(ATTR_TITLE));
    if (!rotulo) {
      el.setAttribute(DONE, "sem-rotulo");
      return;
    }
    var texto = el.textContent || "";
    if (padraoColecao().test(texto)) el.textContent = texto.replace(padraoColecao(), rotulo);
    el.setAttribute(DONE, "1");
  }

  /* Item de menu: o texto do elemento e so o codigo, entao troca inteiro.
     O elemento nunca envolve icone - o Liquid poe um <span> so pro rotulo. */
  function rotular(el) {
    var rotulo = rotuloDe(el.getAttribute(ATTR_LABEL));
    if (!rotulo) {
      el.setAttribute(DONE, "sem-rotulo");
      return;
    }
    if (el.textContent !== rotulo) el.textContent = rotulo;
    el.setAttribute(DONE, "1");
  }

  function tratar(el) {
    if (!el || el.nodeType !== 1 || el.hasAttribute(DONE)) return;
    if (!el.hasAttribute(ATTR_PREFIX) && !el.hasAttribute(ATTR_TITLE) && !el.hasAttribute(ATTR_LABEL)) return;
    /* dicionario ainda nao chegou: guarda pra reescrever assim que chegar */
    if (!MAP) {
      fila.push(el);
      return;
    }
    if (el.hasAttribute(ATTR_PREFIX)) prefixar(el);
    else if (el.hasAttribute(ATTR_LABEL)) rotular(el);
    else substituir(el);
  }

  function varrer(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    var sel =
      "[" + ATTR_PREFIX + "]:not([" + DONE + "]), [" + ATTR_TITLE + "]:not([" + DONE + "]), [" + ATTR_LABEL + "]:not([" + DONE + "])";
    var alvos = raiz.querySelectorAll(sel);
    for (var i = 0; i < alvos.length; i++) tratar(alvos[i]);
  }

  /* Na pagina de colecao tambem trocamos title/description/og:title.
     Na PDP NAO se mexe em metadado: la o generico e proposital. */
  function reescreverMetaDaColecao() {
    var marca = document.querySelector("[" + ATTR_TITLE + "]");
    if (!marca) return;
    var rotulo = rotuloDe(marca.getAttribute(ATTR_TITLE));
    if (!rotulo) return;
    try {
      if (document.title) document.title = document.title.replace(padraoColecao(), rotulo);
      var md = document.querySelector('meta[name="description"]');
      if (md && md.getAttribute("content")) {
        md.setAttribute("content", md.getAttribute("content").replace(padraoColecao(), rotulo));
      }
      var og = document.querySelector('meta[property="og:title"]');
      if (og && og.getAttribute("content")) {
        og.setAttribute("content", og.getAttribute("content").replace(padraoColecao(), rotulo));
      }
    } catch (e) {}
  }

  /* ---------- inicio ---------- */

  /* 1) cache primeiro: se houver, MAP fica pronto de forma sincrona e nao ha flash */
  var emCache = doCache();
  if (emCache) MAP = emCache;

  /* 2) observer instalado ainda durante o parse do HTML */
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (mutacoes) {
      for (var i = 0; i < mutacoes.length; i++) {
        var novos = mutacoes[i].addedNodes;
        for (var j = 0; j < novos.length; j++) {
          var n = novos[j];
          if (n.nodeType !== 1) continue;
          tratar(n);
          varrer(n);
        }
      }
    });
    obs.observe(document.documentElement || document, { childList: true, subtree: true });
  }

  /* 3) sem cache valido, busca no servico. Com cache, confere depois do load se o
     dicionario mudou - o cache resolve a exibicao na hora, a conferencia so corrige
     o que ficou sem rotulo, e por rodar depois do load nao disputa banda com a pagina. */
  if (!MAP) buscar();
  else window.addEventListener("load", function () { buscar(true); });

  function passada() {
    varrer(document);
    if (MAP) reescreverMetaDaColecao();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", passada);
  else passada();
  window.addEventListener("load", passada);
  document.addEventListener("shopify:section:load", passada);
})();
